import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { loginAsSuscriptor, logoutAsSuscriptor } from "redux/actions/aLogin";
import BreadCurmb from "../../components/BreadCrumbMex/BreadCrumb";
import Page from "../../components/Page";
import Loading from "../../wrappers/Loading";
import "./styles.scss";

const PerfilContainer = ({ loading, dataUsuario, history }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      dataUsuario?.isSuscriptor &&
      dataUsuario?.usu_tipo_usuario !== "usu-suscriptor-sbs"
    ) {
      if (dataUsuario?.sesionSuscriptor) {
        const { sesionSuscriptor } = dataUsuario;
        dispatch(loginAsSuscriptor(sesionSuscriptor));
      } else {
        dispatch(logoutAsSuscriptor());
        return history.push("/");
      }
    }
  }, []);

  const clavesAgente = useMemo(() => {
    if (
      !dataUsuario?.agente ||
      !dataUsuario?.agente?.length ||
      dataUsuario?.agente?.length === 0
    ) {
      return "N/A";
    }
    return (
      <table className='table table-responsive-sm table-bordered table-sm w-100'>
        <thead>
          <tr>
            <th>Clave</th>
            <th>Agente</th>
            <th>Sucursal</th>
          </tr>
        </thead>
        <tbody>
          {dataUsuario?.agente.map((agente) => (
            <tr key={agente.clave}>
              <td>{agente?.clave}</td>
              <td>{agente?.nombre}</td>
              <td>{agente?.sucursal}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }, [dataUsuario]);

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCurmb title='Mi Perfil' subtitle='Mi Perfil' />

          <div className='row justify-content-center'>
            <div className='col-11 col-md-10'>
              <div className='card border'>
                <div className='card-header '>
                  <h3 className='font-mex'>DATOS DEL USUARIO</h3>
                </div>
                <div className='card-body '>
                  <div className='row text-center text-md-left'>
                    <div className='col-md-6'>
                      <p>Nombres del usuario:</p>
                      <h5>{dataUsuario.nombres}</h5>
                    </div>
                    <div className='col-md-6'>
                      <p>Apellidos del usuario:</p>
                      <h5>{dataUsuario.apellidos}</h5>
                    </div>
                    <div className='col-md-6'>
                      <p>Identificación:</p>
                      <h5>{dataUsuario.cedula}</h5>
                    </div>
                    <div className='col-md-6'>
                      <p>Correo electrónico del usuario:</p>
                      <h5>{dataUsuario.correo}</h5>
                    </div>

                    <div className='col-md-12'>
                      <p>Claves de agente:</p>
                      <h5>{clavesAgente}</h5>
                    </div>

                    <div className='col-md-12'>
                      <Link className='btn btn-mex my-4' to='/cambiar-contrasenia'>
                        Cambiar contraseña
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default PerfilContainer;
